<p-dialog *ngIf="subscriptionDetail !== undefined" [(visible)]="displayDialog" [modal]="true" [draggable]="false" (onHide)="closeDialog()">
    <ng-template pTemplate="header">
        <h3><i class="pi pi-wallet"></i> Registrar pago</h3>
    </ng-template>
    <ng-template pTemplate="content">
        <p-messages key="user" [closable]="false" class="mb-5"></p-messages>
        <form [formGroup]="paymentForm" class="m-2">
            <div class="flex flex-row justify-content-between">
                <div class="field w-6 my-5">
                    <span class="p-input-icon-right p-float-label w-full">
                        <p-calendar styleClass="w-10 p-inputtext-lg" inputId="payDate" formControlName="payDate" 
                            [showIcon]="true" appendTo="body" dateFormat="dd/mm/yy"></p-calendar>
                        <label htmlFor="payDate">Fecha de pago</label>
                    </span>
                </div>
                <div class="field my-5">
                    <span class="p-input-icon-right p-float-label w-full">
                        <input type="text" id="method" pInputText class="p-inputtext-lg w-full" formControlName="method"
                            maxlength="45" size="35"
                            [class.ng-invalid]="this.paymentForm.get('method')?.invalid && this.paymentForm.get('method')?.touched" />
                        <label htmlFor="method">Método de pago</label>
                    </span>
                </div>
            </div>
            
            <div class="field my-5">
                <span class="p-input-icon-right p-float-label w-full">
                    <p-inputNumber inputId="amount" formControlName="amount" prefix="$" [maxlength]="6" styleClass="p-inputtext-lg" 
                        inputStyleClass="w-full" [size]="90"
                        [class.ng-invalid]="this.paymentForm.get('amount')?.invalid && this.paymentForm.get('amount')?.touched"></p-inputNumber>
                    <label htmlFor="amount">Valor pagado</label>
                </span>
            </div>
            <div class="field mb-5">
                <span class="p-float-label">
                    <textarea rows="5" cols="30" id="additionalInfo" pInputTextarea class="p-inputtext-lg w-full" formControlName="additionalInfo"
                        [class.ng-invalid]="this.paymentForm.get('additionalInfo')?.invalid && this.paymentForm.get('additionalInfo')?.touched">
                    </textarea>
                    <label htmlFor="additionalInfo">Detalle (opcional)</label>
                </span>
                <label class="contador">{{ this.paymentForm.get('additionalInfo')?.value.length }}/150</label>
            </div>
        </form>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" icon="pi pi-times" class="grey" (onClick)="closeDialog()" ariaLabel="Cancelar"></p-button>
        <p-button label="Aceptar" icon="pi pi-check" type="submit" (onClick)="savePayment()" [disabled]="this.paymentForm.invalid" ariaLabel="Aceptar"></p-button>
    </ng-template>
</p-dialog>